import React from "react";
import { FC, Fragment, ReactNode } from "react";
import { Form } from "react-bootstrap";

// Define the additional props as a TypeScript interface
interface AdditionalProps {
  formik: any;
}
// Define the props for the generic ParentComponent
interface GenericFormProps extends AdditionalProps {
  handleSubmit: any;
  children: JSX.Element;
}

const cloneChildComponents = (
  children: ReactNode,
  additionalProps: any
): ReactNode => {
  return React.Children.map(children, (child: ReactNode) => {
    if (React.isValidElement(child)) {
      // Clone the child element with the additional props
      return React.cloneElement(child, {
        ...additionalProps,
        children: cloneChildComponents(child.props.children, additionalProps),
      });
    }
    return child;
  });
};

const GenericForm: FC<GenericFormProps> = ({
  formik,
  handleSubmit,
  children,
}) => {
  const childrenWithProps = cloneChildComponents(children, { formik });
  return (
    <Fragment>
      <Form onSubmit={handleSubmit}>{childrenWithProps}</Form>
    </Fragment>
  );
};

export default GenericForm;
